import React from 'react';

import './index.css';

export default (props) => (
    <i className={props.type} onClick={() => {
        typeof props.onClick === 'function' ? props.onClick() : "";
    }}></i>
);